import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP6ChurnedReorder202509: FaireAdPerformancePeriodEntity = {
  token: "perf_p6_churned_reorder_202509",
  type: "adPerformancePeriod",
  scope: "REORDER_MARKETPLACE",
  periodType: "RECEIPT",
  startDate: "2025-09-01",
  endDate: "2025-09-30",
  impressions: 4734,
  clicks: 85,
  adsSpendDollars: 215,
  budgetDollars: 600,
  salesDollars: 2759,
  bestEstimateRoas: 12.83,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.36,
  reorderConversions: 8,
  dataAvailableAtDate: "2025-10-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
